module.exports = __webpack_public_path__ + "img/logo.1bcd9c51.png";